import './CompanyExist.scss';

//import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import SearchIcon from '@mui/icons-material/Search';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import FelicitationIcon from '../../../../Assets/FelicitationIcon.png';
import { buttonStyles } from '../../../../Components/docsAdministrative/JsObjectStyles';
import { IconTextField } from '../../../../Components/shared/ReusableSmallComponents';
import useAuth from '../../../../hooks/useAuth';
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate';
import useRole from '../../../../hooks/useRole';
import { isUrlFromCompleterProfile } from '../../../../Utils/utils';
function ComapyExists(props) {
    ComapyExists.propTypes = {
        isNewCompany: PropTypes.bool,//it could be blob ,,
    };
    const { auth, setAuth } = useAuth();
    console.log('FROM STEP 3', props.isNewCompany);
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const role = useRole();
    const [companies, setCompanies] = useState({});
    const { pathname } = useLocation();
    const { i18n } = useTranslation();
    const navigateToNextStep = () => {
        if (isUrlFromCompleterProfile(pathname)) {
            if (auth.completeStep < 3) {
                setAuth({ ...auth, completeStep: 3 });
            }
            navigate(`/${role}`);
        }
    };
    const sendInvitation = async (e, RefCompany) => {
        e.preventDefault();
        try {
            const response1 = await axiosPrivate.post(`/${role}/inviteCompany`,
                {
                    'ownerEmail': RefCompany,
                    'isFromAccountCompletion': isUrlFromCompleterProfile(pathname),
                });
            const responseData1 = await response1.data;
            console.log('submitresumeBackend', responseData1);
            navigateToNextStep();
            console.log('responseData1.message', responseData1.message);
            Swal.fire({
                title: i18n.t('Félicitation!'),
                imageUrl: FelicitationIcon,
                html:
                    `<p> ${i18n.t('Votre compte a été complété avec succès. Une invitation a été envoyée à votre entreprise. Vous serez notifié(e) dès qu\'elle sera acceptée.')}</p>`,
                confirmButtonText: i18n.t('page d\'accueil'),
                confirmButtonColor: '#5CC889',
            }).then((result) => {
                if (result.isConfirmed) {
                    navigateToNextStep();
                }
            });
        } catch (error) {
            console.log(error.response?.status);
            console.log('error.response?.data.error', error.response?.data.error);
            Swal.fire({
                text: i18n.t(error.response?.data.error)
            });
        }
    };

    const searchEntreprise = async (companyName) => {
        if (companyName.length > 2)
            try {
                const response1 = await axiosPrivate.post(`/${role}/searchEntreprise`,
                    { companyName });
                const responseData1 = await response1.data;
                setCompanies(response1.data.companies ?? response1.data.esns);
                console.log('submitresumeBackend', responseData1);
            } catch (error) {
                console.log(error.response);
            }
    };

    return (
        <>
            <div className='Box1E'>
                <h4 className='titlesociete'>{i18n.t('Trouvez votre entreprise et rejoignez la')}</h4>
                <div className='Box2E'>
                    <div className='Box3E'>
                        <div className='Box4E'>
                            <p className='T2E'>{i18n.t('Saisissez le nom de l\'entreprise')}</p>
                            <IconTextField
                                type="search"
                                style={{ borderRadius: '8px', width: '100%', background: 'white' }}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                iconStart={<SearchIcon />}
                                onChange={(e) => {
                                    searchEntreprise(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                </div>
                {companies?.length > 0 &&
                    //? (
                    <div className='frame0CompanyExist'>
                        {companies.map((company, i) => (
                            <div
                                className='frame1CompanyExist'
                                key={i}
                            >
                                <div className='frame2CompanyExist'>
                                    <div className='frame3CompanyExist'>
                                        <div className='frame4CompanyExist'>
                                            <img
                                                src={company?.profileEntreprise.logo}
                                                alt="logo"
                                                style={{ width: '50px', height: '50px', borderRadius: '10px' }}
                                            />
                                        </div>
                                        <div className='frame5CompanyExist'>
                                            <h6 className='frame6CompanyExist'>
                                                {company?.profileEntreprise.nom}
                                            </h6>
                                            <p className='frame7CompanyExist'>
                                                {company?.profileEntreprise.address}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='frame8CompanyExist'>
                                </div>
                                <div className='frame9CompanyExist'>
                                    <Button
                                        variant="outlined"
                                        style={{ ...buttonStyles(false), ...{ height: '40px' } }}
                                        onClick={(e) => {
                                            sendInvitation(e, company?.profileEntreprise?.ownerEmail);
                                        }
                                        }
                                    > {i18n.t('Rejoindre')}
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                }
            </div>
        </>
    );
}

export default ComapyExists;